/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import DayOffService from '../service';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from '../../../components/Modal/NotificationModal';
import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';
import Pagination from 'components/Pagination';
import { toast } from 'react-toastify';
import {
  Container,
  Row,
  Card,
  Button,
  CardHeader,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  FormGroup,
  Label
} from 'reactstrap';
import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../assets/styles/table_custom_style';
import { useHistory } from 'react-router-dom';
import ReactLoader from 'components/Loader';
import { brazilian } from '../../../assets/translator/pt-br/index';
import { IconLogoHeader } from '../../Scales/style/style';
import { useSelector } from 'react-redux';
import { BiAlarmOff } from 'react-icons/bi';
const arrayDays = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday'
];

export default function DayOffList() {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const history = useHistory();
  const [DayOff, setDayOff] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [timeoutID, setTimeoutID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showDisabled, setShowDisable] = useState(false);

  useEffect(() => {
    loadApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDisabled]);

  async function loadApi(page = 1, querySearch = '') {
    setLoading(true);
    const size = 10;
    DayOffService.getAllSearch(showDisabled, size, page, querySearch).then(
      (response) => {
        const { DAYS } = brazilian;
        setQuantity(response.data.totalRegisters);
        const FormatedData = response.data.data;
        response.data.data.forEach((scale, index) => {
          let listDays = [];
          arrayDays.forEach((day) => {
            if (scale[day] === true) {
              for (let [key, value] of Object.entries(DAYS)) {
                if (key === day) listDays.push(value);
              }
            }
          });
          const joinDays = listDays.join(' , ');
          FormatedData[index] = { ...scale, joinDays };
        });
        setDayOff(FormatedData);
        setLoading(false);
      }
    );
  }

  function handleUpdate(id) {
    history.push(`DayOff/form/${id}`);
  }

  const changeActive = async (data) => {
    if (!data.disabled) {
      if (!window.confirm('Tem certeza que deseja desabilitar a folga?'))
        return;
      DayOffService.delete(data.id)
        .then(() => {
          toast.info('Folga desabilitada com sucesso');
          loadApi();
        })
        .catch((err) => {
          toast.error(err.response?.data.error[0]);
        });
    } else {
      if (data.numberOfOccurrences === null) {
        const FormatedData = {
          ...data,
          disabled: false,
          userLogins: data.users.map((res) => {
            return res.login;
          }),
          numberOfOccurrences: 0
        };
        DayOffService.put(data.id, FormatedData)
          .then(() => {
            toast.info('Folga habilitada com sucesso');
            loadApi();
          })
          .catch((err) => {
            toast.error(err.response?.data.error[0]);
          });
      } else {
        const FormatedData = {
          ...data,
          disabled: false,
          userLogins: data.users.map((res) => {
            return res.login;
          })
        };
        DayOffService.put(data.id, FormatedData)
          .then(() => {
            toast.info('Folga habilitada com sucesso');
            loadApi();
          })
          .catch((err) => {
            toast.error(err.response?.data.error[0]);
          });
      }
    }
  };
  const handlePageChange = (page) => {
    setActivePage(page);
    loadApi(page);
  };

  const handleOnSearch = (event) => {
    if (typeof timeoutID === 'number') {
      clearTimeout(timeoutID);
    }
    const q = event.target.value;
    setTimeoutID(
      setTimeout(() => {
        loadApi(1, q);
      }, 1000)
    );
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/DayOff/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row className="mt-3 mx-2">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '1rem',
                    alignItems: 'center'
                  }}
                >
                  <IconLogoHeader
                    backgroundColor={systemConfiguration.primary_color}
                  >
                    <BiAlarmOff color="white" size={25} />
                  </IconLogoHeader>
                  <h3>Folgas</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Buscar folga"
                          type="text"
                          onChange={handleOnSearch}
                        />
                      </InputGroup>
                    </Col>
                    <Col md="4" className="text-right mt-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={showDisabled}
                            onChange={() => setShowDisable(!showDisabled)}
                          />
                          <span>Mostrar desabilitados</span>
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={DayOff}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'endCriteria',
                      text: 'Críterio de termino',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'repeatPattern',
                      text: 'Padrão de repetição',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'joinDays',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Dias de Folga',
                      // eslint-disable-next-line react/display-name
                      formatter: (rowContent) => {
                        return (
                          <i
                            className="fas fa-info-circle"
                            size="sm"
                            datatoggle="tooltip"
                            dataplacement="top"
                            title={rowContent}
                            datacontainer="body"
                            dataanimation="true"
                            style={{ fontSize: '25px', color: '#2dce89' }}
                          />
                        );
                      }
                    },
                    {
                      dataField: 'usuarios',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'usuários',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Modal>
                            <strong>Usuário</strong>
                            {row.users.map((res, key) => {
                              return <p key={key}>{res.login}</p>;
                            })}
                          </Modal>
                        );
                      }
                    },
                    {
                      dataField: 'disabled',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Habilitar / Desabilitar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <ToggleSwitch
                            checked={!row.disabled}
                            name={row.name}
                            id={row.id}
                            onChange={() => changeActive(row)}
                          />
                        );
                      }
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            title={'Editar Perfil'}
                            onClick={() => handleUpdate(row.id)}
                          >
                            <li className="fas fa-clone"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
